import { render, staticRenderFns } from "./NormativaAnexoItem.vue?vue&type=template&id=6cba351e&scoped=true"
import script from "./NormativaAnexoItem.vue?vue&type=script&lang=js"
export * from "./NormativaAnexoItem.vue?vue&type=script&lang=js"
import style0 from "./NormativaAnexoItem.vue?vue&type=style&index=0&id=6cba351e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cba351e",
  null
  
)

export default component.exports